module.exports = __webpack_public_path__ + "static/img/about_h5_parterment.86347fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_h5_parterment.png
// module id = Ik6U
// module chunks = 34